const TokenKey = 'token'
const OpenIdKey = 'openidKey'
const CodeIdKey = 'codeidKey'
const MainpageKey = 'MainpageKey'
const MainparamsKey = 'MainparamsKey'


export function getCode() {
  return localStorage.getItem(CodeIdKey)
}

export function setCode(token) {
  return localStorage.setItem(CodeIdKey, token)
}

export function removeCode() {
  return localStorage.removeItem(CodeIdKey)
}

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function removeMainParams() {
  return localStorage.removeItem(MainparamsKey)
}

export function getOpenId() {
    return localStorage.getItem(OpenIdKey)
  }

export function setOpenId(openid) {
    return localStorage.setItem(OpenIdKey, openid)
}
